module.exports = __webpack_public_path__ + "static/media/icon_lixo.73ecce97.svg";